//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import { faSparkles, faSparkle } from '@fortawesome/pro-solid-svg-icons';
import { getMediaTypeGroup } from '@motionelements/core/src/services/catalog.service.js';
import studioAiMixin from '@motionelements/core/src/components/mixins/studio-ai.mixin.js';
import AiToolsMixin from '@motionelements/core/src/components/mixins/ai-tools.mixin.js';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import { getElementAiTools } from '@motionelements/core/src/api/elements.js';
import { downloadElement } from '@motionelements/core/src/services/download.service.js';

export default {
  name: 'AiToolsSidebar',
  components: {
    LoaderSpin: () => import('@motionelements/core/src/components/ui/LoaderSpin.vue'),
  },
  mixins: [studioAiMixin, AiToolsMixin, featureFlagMixin],
  props: {
    productId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      faSparkles,
      faSparkle,
      //
      popupTop: 0,
      elementAiTools: [],
      //
      isProductDownloading: false,
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
    ...mapGetters({
      mediaType: 'product/mediaType',
      currentVariantFormat: 'product/currentVariantFormat',
      isDownloadable: 'product/isDownloadable',
      isDownloadableDirectly: 'product/isDownloadableDirectly',
      masterVariant: 'product/masterVariant',
      hasUnlimitedSubscription: 'user/hasUnlimitedSubscription',
    }),
    mediaTypeGroup() {
      return getMediaTypeGroup(this.mediaType);
    },
    canUseElementAiToolUrl() {
      return this.isLoggedIn && this.hasUnlimitedSubscription;
    },
    productAiToolsFiltered() {
      const elementToolIds = this.elementAiTools.map(({ id }) => id);
      return this.aiTools
        .filter(({ id }) => elementToolIds.includes(id))
        .map((tool) => {
          const elementTool = this.elementAiTools.find(({ id }) => id === tool.id);
          return {
            ...tool,
            elementUrl: elementTool?.url,
          };
        });
    },
  },
  watch: {
    productId() {
      this.loadElementAiTools();
    },
  },
  mounted() {
    this.loadElementAiTools();
  },
  methods: {
    getMediaTypeGroup,
    aiToolTrackClass(id) {
      return `track-product-ai-tool-${String(id).replace(/_/g, '-')}`;
    },
    calculatePopupTop(event) {
      this.popupTop = event.target.offsetTop - this.$refs.scrollArea.scrollTop;
    },
    loadElementAiTools() {
      getElementAiTools(this.productId)
        .then(({ data: { data: tools } }) => {
          this.elementAiTools = tools;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getAiToolLink(tool) {
      if (this.canUseElementAiToolUrl && tool.elementUrl) {
        return this.$link(tool.elementUrl).param('sku', this.productId).aiUrl();
      }
      return this.$link(`${tool.link}?sku=${this.productId}`).aiUrl();
    },
    handleTryAiTool(tool) {
      if (!this.hasUnlimitedSubscription) {
        window.location.href = this.$link('/subscribe').url();
      } else {
        this.isProductDownloading = true;
        downloadElement({
          method: 'subscription',
          sku: this.masterVariant.id,
        })
          .then(() => {
            window.open(this.getAiToolLink(tool), '_blank', 'noopener,noreferrer');
          })
          .finally(() => {
            this.isProductDownloading = false;
          });
      }
    },
  },
};
